import styled from "styled-components";

export const Container = styled.div`
    padding: 20px;
    width: 100%;
    
    @media (max-width: 850px) {
        padding: 20px 0px;
    }
`;

export const TituloBlocoPendencias = styled.div`
    font-size: 18px;
    color: ${({ theme }) => theme.colors.c000000};
    font-weight: 600;
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    flex-shrink: 0;
`;
